declare namespace $ {

	export class $mol_icon_checkbox_marked_outline extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=outline.view.tree.d.ts.map